// # import всіх елементів в формі:
// # INPUT "при наведені на текст він піднімається"
// # list список такий як в брифі
// # texaria 

import './input'
import './textarea'
import './radio'
import './list'